export const unknownFreeBusy = "Bo0B0c";
export default {unknownFreeBusy};